export const env = {
  baseUrl: import.meta.env.VITE_APP_BASE_URL,
  apiUrl: import.meta.env.VITE_APP_API_URL,
  jwtPublicKey: import.meta.env.VITE_APP_JWT_PUBLIC_KEY,
  cmsUrl: import.meta.env.VITE_APP_CMS_URL,
  cmsToken: import.meta.env.VITE_APP_CMS_TOKEN,
  ndcContentUrl: import.meta.env.VITE_APP_NDC_CONTENT,
  nodeEnv: import.meta.env.MODE,
};
